import React from "react"
import { Formik } from "formik"
import { CustomInput, FormGroup, Input, Label } from "reactstrap"
import InputMask from "react-input-mask"
import { isValidPhone } from "../../common/validations"
import { AsyncSelect, Spinner } from "../../components"
import { TimeUtil } from "../../utils"

const ExamUserInterestsForm = ({
  setCurso,
  setCidade,
  getCourses,
  getCities,
  parentHandleChange,
  handleSubmit,
}) => (
  <div>
    <Formik
      initialValues={{
        curso: null,
        cidade: null,
        telefone: null,
        aceitouTermos: null,
        concluiuEnsinoMedio: null,
        interesseEmBolsa: null,
        currentSituation: "",
      }}
      validate={(values) => {
        const errors = {}
        if (!values.curso) {
          errors.curso = "Informe o curso"
        }
        if (!values.cidade) {
          errors.cidade = "Informe a cidade"
        }
        if (!values.telefone) {
          errors.telefone = "Informe o telefone"
        } else if (
          !/^[0-9]{2}\s[0-9]{1}\s[0-9]{4}\s[0-9]{4}$/im.test(values.telefone)
        ) {
          errors.telefone = "Informar no formato 31 9 9999 9999"
        } else {
          const error = isValidPhone(values.telefone)
          if (error != null) {
            errors.telefone = error
          }
        }

        if (!values.aceitouTermos) {
          errors.aceitouTermos = "É necessário concordar com os termos de uso"
        } else if (values.aceitouTermos[0] !== "on") {
          errors.aceitouTermos = "É necessário concordar com os termos de uso"
        }

        if (!values.concluiuEnsinoMedio) {
          errors.concluiuEnsinoMedio = "Informe se concluiu o ensino médio"
        }

        if (!values.interesseEmBolsa) {
          errors.interesseEmBolsa = "Informe se você tem interesse em bolsa"
        }

        if (!values.currentSituation) {
          errors.currentSituation = "Informe sua situação atual"
        }

        return errors
      }}
      onSubmit={(values, { setSubmitting }) => {
        handleSubmit({
          values,
          callback: () => setSubmitting(false),
        })
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        /* and other goodies */
      }) => (
        <form onSubmit={(e) => handleSubmit(e)}>
          <h4 className="bold text-center">
            Para ver seu desempenho preencha os campos abaixo
          </h4>
          <span className="error-legend red">
            {touched.curso && errors.curso}
          </span>
          <AsyncSelect
            name="curso"
            placeholder="Curso de interesse"
            onChange={(value) => {
              setCurso(value)
              setFieldValue("curso", value.value)
            }}
            loadOptions={(inputValue) => getCourses(inputValue)}
            required
          />
          <span className="error-legend red">
            {touched.cidade && errors.cidade}
          </span>
          <AsyncSelect
            name="cidade"
            placeholder="Cidade que deseja estudar"
            onChange={(value) => {
              setCidade(value)
              setFieldValue("cidade", value.value)
            }}
            loadOptions={(inputValue) => getCities(inputValue)}
            required
          />
          <span className="error-legend red">
            {touched.telefone && errors.telefone}
          </span>
          <InputMask
            mask="99 9 9999 9999"
            maskChar="_"
            onChange={(e) => {
              handleChange(e)
              parentHandleChange(e)
            }}
          >
            {(inputProps) => (
              <input
                {...inputProps}
                type="text"
                name="telefone"
                placeholder="Digite o seu número de telefone"
              />
            )}
          </InputMask>
          <span className="error-legend red">
            {touched.concluiuEnsinoMedio && errors.concluiuEnsinoMedio}
          </span>
          <FormGroup tag="fieldset" className="interests-radio-section">
            <div>Concluiu o Ensino Médio?</div>

            <Label check className="interests-radio-item">
              <Input
                type="radio"
                name="concluiuEnsinoMedio"
                value="Sim"
                onChange={(e) => {
                  handleChange(e)
                  parentHandleChange(e)
                }}
              />{" "}
              Sim
            </Label>
            <Label check className="interests-radio-item">
              <Input
                type="radio"
                name="concluiuEnsinoMedio"
                value="Não"
                onChange={(e) => {
                  handleChange(e)
                  parentHandleChange(e)
                }}
              />{" "}
              Não
            </Label>
            <Label check className="interests-radio-item">
              <Input
                type="radio"
                name="concluiuEnsinoMedio"
                value="Estou no último ano"
                onChange={(e) => {
                  handleChange(e)
                  parentHandleChange(e)
                }}
              />{" "}
              Estou no último ano
            </Label>
          </FormGroup>

          <span className="error-legend red">
            {touched.interesseEmBolsa && errors.interesseEmBolsa}
          </span>
          <FormGroup tag="fieldset" className="">
            <div>
              Você deseja entrar em uma faculdade particular agora{" "}
              {TimeUtil.currentYear} com a ajuda do Beduka?
            </div>

            <Label check className="text-left">
              <Input
                type="radio"
                name="interesseEmBolsa"
                value="Sim"
                onChange={(e) => {
                  handleChange(e)
                  parentHandleChange(e)
                }}
              />{" "}
              Sim
            </Label>
            <Label check className="text-left">
              <Input
                type="radio"
                name="interesseEmBolsa"
                value="Não"
                onChange={(e) => {
                  handleChange(e)
                  parentHandleChange(e)
                }}
              />{" "}
              Não
            </Label>
          </FormGroup>

          <span className="error-legend red">
            {touched.currentSituation && errors.currentSituation}
          </span>
          <FormGroup tag="fieldset" className="">
            <div>Qual é a sua situação atual?</div>

            <Input
              type="select"
              name="currentSituation"
              id="select-current-situation"
              onChange={(e) => {
                handleChange(e)
                parentHandleChange(e)
              }}
            >
              <option disabled value="">
                Escolha uma opção
              </option>
              <option value="Apenas estudando">Apenas estudando</option>
              <option value="Estudando e trabalhando">
                Estudando e trabalhando
              </option>
              <option value="Apenas trabalhando">Apenas trabalhando</option>
            </Input>
          </FormGroup>

          <span className="error-legend red">
            {touched.aceitouTermos && errors.aceitouTermos}
          </span>
          {/* <div className='form-group mb-4 text-white'> */}
          <div className="d-flex">
            <CustomInput
              type="checkbox"
              id="aceitouTermos"
              name="aceitouTermos"
              onChange={(e) => {
                handleChange(e)
                parentHandleChange(e)
              }}
              className="text-left"
            />
            <p className="no-margin text-left">
              Concordo com os &nbsp;
              <a
                href="/termos-de-uso.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-underline text-white font-weight-bold"
              >
                termos de uso
              </a>{" "}
              &nbsp; do Beduka.
            </p>
          </div>

          {/* </div> */}
          <div className="modal-button-bar modal-button-bar_margin">
            {!isSubmitting && (
              <button
                type="submit"
                className="success medium button"
                disabled={isSubmitting}
              >
                Enviar
              </button>
            )}
            {isSubmitting && <Spinner isLoading={isSubmitting} />}
          </div>
        </form>
      )}
    </Formik>
  </div>
)

export default ExamUserInterestsForm
